import request from '../../../helpers/request';

const changeHeadOfHouse = async (houseId, values, addType = false) => {
  const response = await request.put(
    `/HousingStock/house/${houseId}/head`,
    values,
    `При ${
      addType ? 'добавлении' : 'изменении'
    } председателя совета дома произошла ошибка`
  );

  return response;
};

export default changeHeadOfHouse;
